import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FormControlLabel, Typography, SxProps, Theme } from '@mui/material';
import { TmSwitch } from '../TmSwitch';

interface TmSwitchFormControlProps {
    name: string;
    label: string;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
    sx?: SxProps<Theme>;
}

export const TmSwitchFormControl: React.FC<TmSwitchFormControlProps> = ({ 
    name, 
    label, 
    disabled = false,
    onChange,
    sx 
}) => {
    const { control } = useFormContext();

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={false}
            render={({ field }) => (
                <FormControlLabel
                    label={label ? <Typography className="ltb" variant="body1" sx={{ fontSize: '14px', pt: 0 }}>{label}</Typography> : ""}
                    labelPlacement={label ? "start" : "end"}
                    control={
                        <TmSwitch
                            checked={field.value ?? false}
                            onChange={(e) => {
                                const newValue = e.target.checked;
                                field.onChange(newValue);
                                if (onChange) {
                                    onChange(newValue);
                                }
                            }}
                            disabled={disabled}
                        />
                    }
                    sx={{
                        pt: 0,
                        mt: 0,
                        mb: 0,
                        '& .MuiFormControlLabel-label': { flex: 1 },
                        ...sx
                    }}
                />
            )}
        />
    );
};

